import { IconX } from '@tabler/icons-react';
import { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import soundSuccess from '../../../src/assets/sound.mp3';
import { CurrencyInput } from '../../utils/CurrencyInput';
import Stroke from '../Kasir/Stroke';
import TestingPrint from '../Kasir/TestingPrint';
import CetakStroke from '../Kasir/CetakStroke';
import { getAuthorizationHeader, http } from '../../config/http';
import PrintSuratTrxPenjualan from '../Transaksi/PrintSuratTrxPenjualan';
import SuratKeruak from '../Transaksi/SuratKeruak';
import SuratToko from '../../components/surat/SuratToko';
import { imageBaseUrl } from '../../config/http'

export default function DetailTransaksiTertunda({ itemCabang, detailPenjualan, isTertunda, kodeItem, loading }) {
  // console.log('itemCabang::: ', itemCabang);
  const [hargaPenjualan, setHarga] = useState(0);
  const [msg, setMsg] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);
  const [harga_jual, setHargaJual] = useState('');

  const [dataPrint, setDataPrint] = useState([]);
  // console.log('dataPrint::: ', dataPrint);
  let [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();
  const item_id = itemCabang.id;
  

  function playSound() {
    new Audio(soundSuccess).play();
  }

  const handleChange = (newValue) => {
    if (newValue === undefined) {
      setHarga(0);
    } else {
      setHarga(newValue);
      setHargaJual(newValue);
    }
  };
  const [gambar, setGambar] = useState('');
  // console.log('gambar::: ', gambar);
  const toko = localStorage.getItem('name');
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  const compSurat = useRef();


  const SubmitPenjualan = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    const data = { harga_jual, item_id, gambar };
    try {
      const res = await http.post('/transaksi_tertunda', data, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setIsOpen(true);
      playSound();
      setDataPrint(res.data.data);
      return res.data;
    } catch (error) {
      if (error.response.status === 404) {
        toast.error('Data tidak ditemukan', { autoClose: 600, });
      } else if (error.response.status === 422) {
        toast.error('Input harga tidak boleh kosong', { autoClose: 600, });
      } else if (error.response.status === 409) {
        toast.error('Silahkan scan qrcode', { autoClose: 600, });
      } else {
        toast.error('Terjadi kesalahan di server', { autoClose: 600, });
      }
    }
    setBtnLoading(false);
  };

  // print struk
  const strukComponent = useRef();

  function closeModal() {
    setIsOpen(false);
  }

  function checkBerat(number) {
    const beratConfirm = parseFloat(number);
    return beratConfirm % 1 === 0
      ? beratConfirm.toString()
      : beratConfirm
        .toFixed(2)
        .replace(/\.?0+$/, '')
        .replace('.', ',');
  }

  const [selectImage, setSelectImage] = useState([]);
  // console.log('selectImage::: ', selectImage);
  const handleImageChange = (event) => {
    const selectedFiles = event.target.files;
    // console.log('selectedFiles::: ', selectedFiles);
    const selectedFilesArray = Array.from(selectedFiles);

    if (selectImage.length < 1) {
      const reader1 = new FileReader();
      reader1.addEventListener('load', function () {
        setGambar(reader1.result.split(',')[1]);
      });
      reader1.readAsDataURL(selectedFiles[0]);
    }
    // const file = event.target.files[0];
    const imagesArray = selectedFilesArray.map((file) => {
      return URL.createObjectURL(file);
    });
    // setSelectImage((previousImages) => previousImages.concat(imagesArray));
    setSelectImage(imagesArray);
    // FOR BUG IN CHROME
    event.target.value = '';
  };

  function deleteHandler(image) {
    setSelectImage(selectImage.filter((e) => e !== image));
    setGambar('');
    URL.revokeObjectURL(image);
  }

  const tipe_surat = localStorage.getItem('tipe_surat');
  
  const src = (Array.isArray(itemCabang) && itemCabang.length > 0) || (!Array.isArray(itemCabang) && itemCabang) ? `${imageBaseUrl}${itemCabang?.gambar1[0]?.asli}` : '';

  return (
    <>
      <div className="flex-wrap mt-4 md:px-10 lg:px-20">
        <div className="bg-white dark:bg-slate-800 shadow dark:shadow-slate-900/50 rounded-md p-3 transition-colors duration-300">
          <h1 className='uppercase font-semibold text-lg border-b dark:border-slate-700 mx-5 text-gray-800 dark:text-slate-200'>Penggarus {toko}</h1>
          <form onSubmit={SubmitPenjualan} className="rounded-md mt-2 p-4 text-gray-800 dark:text-slate-200">
            <div>
              {msg && (
                <div className="text-2xl flex items-center justify-center font-semibold text-gray-700 dark:text-gray-300">{msg}</div>
              )}
            </div>
            <div>
              {/* {tipe_surat === '1' ? (
                <div
                  ref={strukComponent}
                  className="invisible print:visible absolute bg-white print:h-screen print:w-full"
                >
                  <PrintSuratTrxPenjualan isTertunda isOpen={isOpen} detailPenjualan={dataPrint}/>
                  
                </div>
              ) : (
                <div
                  ref={strukComponent}
                  className="invisible print:visible absolute bg-white print:h-screen print:w-full"
                >
                  <TestingPrint isOpen={isOpen} dataPrint={dataPrint} checkBerat={checkBerat} isTertunda />
                </div>
              )} */}
              {tipe_surat === '1' ? (
                <div ref={strukComponent} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
                  <PrintSuratTrxPenjualan isOpen={isOpen} detailPenjualan={dataPrint} isTertunda={isTertunda} />
                </div>
              ) : tipe_surat === '2' ? (
                <div ref={strukComponent} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
                  <TestingPrint isOpen={isOpen} dataPrint={dataPrint} detailPenjualan={dataPrint} isTertunda={isTertunda} />
                </div>
              ) : tipe_surat === '3' ? (
                <div ref={strukComponent} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
                  <SuratKeruak isOpen={isOpen} detailPenjualan={dataPrint} isTertunda={isTertunda} />
                </div>
              ) : tipe_surat === '4' ? (
                <div ref={strukComponent} className="invisible print:visible absolute bg-white print:h-screen print:w-full">
                  <SuratToko isOpen={isOpen} detailPenjualan={dataPrint} isTertunda={isTertunda} />
                </div>
              ) : null}
              <div className="w-full ">
                <div className="font-medium text-gray-800 dark:text-slate-200">
                  <center><div className="items-center p-2 mb-2 border-b dark:border-slate-700">
                    {!src ? '' :
                          <img className="items-center rounded-lg" width={'400px'} src={src}
                            height={'250px'} alt="" />
                    }
                  </div></center>
                  <div className="flex justify-between items-center p-2 mb-2 border-b dark:border-slate-700">
                    <div className="text-gray-600 dark:text-slate-400">Kode Barang</div>
                    <div className="font-semibold text-gray-900 dark:text-slate-100">{loading ? 'memuat data...' : <>{itemCabang.kode_item}</>}</div>
                  </div>
                  <div className="flex justify-between items-center p-2 mb-2 border-b dark:border-slate-700">
                    <div className="text-gray-600 dark:text-slate-400">Nama Barang</div>
                    <div className="font-semibold text-gray-900 dark:text-slate-100">{loading ? 'memuat data...' : <>{itemCabang.jenis_kategori?.nama_jenis}</>}</div>
                  </div>
                  <div className="flex justify-between items-center p-2 mb-2 border-b dark:border-slate-700">
                    <div className="text-gray-600 dark:text-slate-400">Berat</div>
                    <div className="font-semibold text-gray-900 dark:text-slate-100">{loading ? 'memuat data...' : <>{itemCabang.berat} gram</>}</div>
                  </div>
                  <div className="flex justify-between items-center p-2 mb-2 border-b dark:border-slate-700">
                    <div className="text-gray-600 dark:text-slate-400">Emas</div>
                    <div className="font-semibold text-gray-900 dark:text-slate-100">{loading ? 'memuat data...' : <>{itemCabang.karat} karat</>}</div>
                  </div>
                  <div className="flex justify-between items-center p-2 mb-2">
                    <div className="text-gray-600 dark:text-slate-400">Total Harga</div>
                    <div>
                      <CurrencyInput
                        value={hargaPenjualan}
                        onChange={handleChange}
                        className="input input-bordered w-full max-w-xs bg-white dark:bg-slate-700 text-gray-900 dark:text-slate-200 border-gray-300 dark:border-slate-600 focus:outline-amber-400 focus:border-amber-400"
                      />
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-2 mb-2 border-b dark:border-slate-700">
                    <div className="text-gray-600 dark:text-slate-400">Harga Rata - Rata</div>
                    <div>
                      <p className='text-xl font-bold text-gray-900 dark:text-slate-100'>Rp. {numberWithCommas(itemCabang.berat ? Math.round(hargaPenjualan / itemCabang.berat) : '')}</p>
                    </div>
                  </div>
                  <div className="mb-3 hidden">
                    <div>
                      <div className={`mt-2 flex gap-4 p-2  ${selectImage.length === 0 ? 'hidden' : ''}`}>
                        {selectImage.map((image, index) => (
                          <div key={index}>
                            <button
                              onClick={() => deleteHandler(image)}
                              className="absolute bg-white/50 rounded-full p-1"
                            >
                              <IconX width={20} />
                            </button>
                            <img width={90} src={image} alt="" srcSet="" />
                          </div>
                        ))}
                      </div>
                      <div>
                        {selectImage.length > 0 &&
                          (selectImage.length > 1 ? (
                            <div>
                              <p className="text-sm mx-3 text-red-500">
                                Kamu Hanya bisa Upload 1 Gambar <br />
                                <span className="text-sm">
                                  Silahkan Hapus <b> {selectImage.length - 1} </b> dari {selectImage.length} Gambar
                                  diatas
                                </span>
                              </p>
                            </div>
                          ) : (
                            <div className="text-sm text-green-600 mx-3">
                              UPLOAD {selectImage.length} IMAGE
                              {selectImage.length === 1 ? '' : 'S'}
                            </div>
                          ))}
                      </div>
                      <div className="flex justify-between p-2 mb-2 items-center">
                        <div>Masukkan Gambar</div>
                        <input
                          type="file"
                          onChange={handleImageChange}
                          className="
                        file:bg-blue-500 file:rounded-md file:border-none w-[230px]  file:p-2 file:text-white file:cursor-pointer
                          bg-green-500/20 rounded-md  p-2 font-semibold
                        "
                          multiple
                          accept="image/png , image/jpeg, image/webp"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <CetakStroke strukComponent={strukComponent} closeModal={closeModal} isOpen={isOpen} />
              <div className="mt-5 flex items-center justify-end">
                <button
                  disabled={btnLoading ? true : false}
                  onClick={SubmitPenjualan}
                  className="bg-orange-500 text-white
                  px-3 py-1.5 hover:bg-orange-600 transition duration-300"
                >
                  {btnLoading ? 'Proses ...' : 'Simpan Penggarus'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
